import { Map, List } from 'immutable';
import { createSelector } from 'reselect';

import {
  filtersItems,
} from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersSelectors';

import { listIdsToListItemsForMapFn } from '@Utils';


export function filter (state, ownProps) {
  const { filterId } = ownProps;

  return filtersItems(state).get(filterId);
}

export function thesaurusGroups (state, ownProps) {
  return filter(state, ownProps).get('thesaurusGroups');
}

function groupByForThesaurusFn (item) {
  return item.get('rootIds').join();
}

function mapGroupedResultForThesaurus (group) {
  return group
    .sort(sortFnForGroupsOfThesaurus);
}


//if 'hasChildren' equal false, that checkbox, push checkboxes to bottom acording to design
function sortFnForGroupsOfThesaurus (a, b) {
  const aHasChildren = a.get('hasChildren');
  const bHasChildren = b.get('hasChildren');

  if (aHasChildren === bHasChildren) {
    return 0;
  }

  if (aHasChildren && !bHasChildren) {
    return -1;
  }

  return 1;
}

export function thesaurusGroupsForViewFactory () {
  const selectedItems = createSelector(
    [thesaurusGroups],
    (thesaurusGroups) => {
      const items = thesaurusGroups.get('items');
      return items
        .filter((item) => {
          return item.get('selected');
        });
    }
  );

  const thesaurusGroupsForView = createSelector(
    [thesaurusGroups],
    (thesaurusGroups) => {
      const items = thesaurusGroups.get('items');
      const ids = thesaurusGroups.get('ids');

      return ids
        .map(listIdsToListItemsForMapFn(items))
        .groupBy(groupByForThesaurusFn)
        .map(mapGroupedResultForThesaurus);
    }
  );

  const thesaurusGroupsPartiallySelectedMap = createSelector(
    [selectedItems],
    (selectedItems) => {
      return selectedItems
        .reduce((res, item) => {
          const rootIds = item.get('rootIds');

          return res.merge(arrOfStringToKeyTrueMap(rootIds));
        }, Map());
    }
  );

  const tags = createSelector(
    [selectedItems, filter],
    (selectedItems, filter) => {
      if (filter.get('selected')) {
        return List([filter]);
      }

      return selectedItems
        .filter((item) => {
          const rootIds = item.get('rootIds');

          if (rootIds.count() === 1) {
            return true;
          }
          const lastRootId = rootIds.last();

          return !selectedItems.getIn([lastRootId, 'selected']);

        })
        .toList();
    },
  );

  function openCloseMap (state, ownProps) {
    return ownProps.openCloseMap;
  }
  const visibleItems = createSelector(
    [thesaurusGroupsForView, openCloseMap],
    (thesaurusGroupsForView, openCloseMap) => {
      return Object
        .keys(openCloseMap)
        .filter((key) => {
          return openCloseMap[key];
        })
        .reduce((res, item) => {
          const items = thesaurusGroupsForView.get(item);

          if (!items) {
            return res;
          }

          return res.concat(items);
        }, List());
    }
  );

  const selectedCount = createSelector(
    [tags],
    (tags) => {
      return tags.reduce((res, item) => {
        const hitCount = item.get('hitCount');

        return res + hitCount;
      }, 0);
    }
  )


  return {
    tags,
    visibleItems,
    selectedItems,
    selectedCount,
    thesaurusGroupsForView,
    thesaurusGroupsPartiallySelectedMap,
  };

}

function arrOfStringToKeyTrueMap (arr) {
  return arr.reduce((res, item) => {
    res[item] = true;

    return res;
  }, {});
}

